import type {SuggestionItems} from '@Components/input-suggestions-dropdown/input-suggestions-dropdown.types';

export const getBusinessProfilesUrlLinkSuggestions = async (): Promise<SuggestionItems> => {
  return (await window.PMW.readLocal('mybusiness/getBusinessProfilesUrlLinkSuggestions')) as SuggestionItems;
};

export const getBusinessProfilesAddressSuggestion = async (): Promise<SuggestionItems> => {
  return (await window.PMW.readLocal('mybusiness/getBusinessProfilesAddressSuggestion')) as SuggestionItems;
};

export const getEventsSuggestions = async (): Promise<SuggestionItems> => {
  return (await window.PMW.readLocal('event/getEventsSuggestionData')) as SuggestionItems;
};
